import Box from '@mui/material/Box';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import React, { ReactNode } from 'react';

type CheckInputProps = CheckboxProps & {
  label?: string | ReactNode;
  error?: string;
};

const CheckInput = React.forwardRef<HTMLButtonElement, CheckInputProps>(
  ({ label, error, ...props }, ref) => (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <FormControlLabel
        control={<Checkbox ref={ref} {...props} color="info" />}
        label={label}
      />
      {error && (
        <Typography color="error" variant="body3">
          {error}
        </Typography>
      )}
    </Box>
  )
);

export default CheckInput;
